import React from "react";

const HeadPhone = () => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.00002 0.666504C4.40502 0.666504 0.666687 4.40484 0.666687 8.99984V12.4523C0.666687 13.3057 1.41419 13.9998 2.33335 13.9998H3.16669C3.3877 13.9998 3.59966 13.912 3.75594 13.7558C3.91222 13.5995 4.00002 13.3875 4.00002 13.1665V8.88067C4.00002 8.65966 3.91222 8.44769 3.75594 8.29141C3.59966 8.13513 3.3877 8.04734 3.16669 8.04734H2.41002C2.87335 4.82234 5.64835 2.33317 9.00002 2.33317C12.3517 2.33317 15.1267 4.82234 15.59 8.04734H14.8334C14.6123 8.04734 14.4004 8.13513 14.2441 8.29141C14.0878 8.44769 14 8.65966 14 8.88067V13.9998C14 14.919 13.2525 15.6665 12.3334 15.6665H10.6667V14.8332H7.33335V17.3332H12.3334C14.1717 17.3332 15.6667 15.8382 15.6667 13.9998C16.5859 13.9998 17.3334 13.3057 17.3334 12.4523V8.99984C17.3334 4.40484 13.595 0.666504 9.00002 0.666504Z"
                fill="#0073C7"
            />
        </svg>
    );
};

export default HeadPhone;
